<nz-form-control>
  <nz-select [ngModel]="value" (ngModelChange)="onValueChange($event)" [nzClearIcon]="customClearIcon"
    [nzSuffixIcon]="customSelectIcon" [nzAllowClear]="nzAllowClear" nzSize="large" nzShowSearch (nzOnSearch)="onSearch($event)"
    [nzCustomTemplate]="customSelectTemplate" [nzDisabled]="disabled" [nzPlaceHolder]="placeholder"
    [nzStatus]="nzStatus || ''" [nzLoading]="nzLoading"
    [class]="showPartnerIcon ? 'search-preffix contacts' : ''">
    <ng-template #customSelectTemplate let-selected>
      <app-avatar-badge [urlProperty]="urlProperty" [labelProperties]="labelProperties" [isCurrency]="isCurrency"
        [entity]="getPartner(selected?.nzValue)"></app-avatar-badge>
    </ng-template>

    @if (options) {
    <nz-option *ngFor="let item of options" [nzLabel]="getOptionLabel(item)"
      [nzValue]="item.id" nzCustomContent>
      <app-avatar-badge [urlProperty]="urlProperty" [labelProperties]="labelProperties" [isCurrency]="isCurrency"
        [entity]="item"></app-avatar-badge>
    </nz-option>
    }

    <!-- Opción para crear nuevo partner-->
    @if (allowCreateNew) {
    <nz-option [nzValue]="'CREATE_NEW'" [nzLabel]="'Agregar ' + createNewSearchText" nzCustomContent>
      <div style="display: flex; align-items: center; gap: 8px; padding: 4px 0; cursor: pointer;"
           (click)="onCreateNewClick($event)">
        <app-st-icon name="add" style="color: #595959; font-size: 18px;"></app-st-icon>
        <span style="color: #595959; font-weight: 500;">Agregar {{ createNewSearchText }}</span>
      </div>
    </nz-option>
    }
  </nz-select>
</nz-form-control>

<ng-template #customClearIcon>
  <app-st-icon class="custom-clear" name="close"></app-st-icon>
</ng-template>

<ng-template #customSelectIcon>
  <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
</ng-template>
